// Stripe Payment Service
// Uses Firebase Callable (httpsCallable) so the correct Cloud Run URL is resolved (Functions v2).

import { processPayment } from './firebase/functions';

export class StripePaymentService {
  static async processPurchase(data: any): Promise<any> {
    try {
      const result = await processPayment(data);
      return result.data;
    } catch (err: any) {
      const msg = err?.message || err?.errorDescription || err?.error || 'Error al procesar el pago';
      throw new Error(typeof msg === 'string' ? msg : 'Error al procesar el pago');
    }
  }
}

